import { jsx as h } from "react/jsx-runtime";
const r = (v) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...v,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        d: "M14.5 5.5h-1.59c-.441-2.275-2.475-4-4.91-4s-4.469 1.725-4.91 4H1.5v5H5v-5h-.369C5.046 4.06 6.4 3 8 3c1.601 0 2.954 1.06 3.368 2.5H11v4.983h.502a2.757 2.757 0 0 1-1.99 2.42V12.2h-1.5v2.307h.75a4.256 4.256 0 0 0 4.244-4.024h1.495V5.498L14.5 5.5ZM3.5 9H3V7h.5v2Zm9-2h.5v1.983h-.5V7Z"
      }
    )
  }
);
export {
  r as Advice
};
